import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { env } from '../environments/environment';
import { PayPalExecutePaymentDto } from './api/payPalExecutePaymentDto';
import { PaymentTransactionDto } from './api/paymentTransactionDto'

@Injectable({
	providedIn: 'root'
})
export class PaymentService {
	constructor(private http: HttpClient) {}

	sendTransactionHash = (res: PaymentTransactionDto) => {
		const body = JSON.stringify(res);
		return this.http.post<any>(`${env.beURL}/payment`, body).toPromise();
	};

	deletePayment = (paymentId: string) => {
		return this.http.delete<any>(`${env.beURL}/payment/${paymentId}`).toPromise();
	}

	deletePayPalPayment(payPalPaymentId: string) {
		return this.http.delete<any>(`${env.beURL}/payment/paypal/${payPalPaymentId}`).toPromise();
	}

	finalizePayPalPayment(payPalPaymentId, payerId): Promise<PayPalExecutePaymentDto> {
		const body = JSON.stringify({ payPalPaymentId, payerId });
		return this.http.post<PayPalExecutePaymentDto>(`${env.beURL}/payment/paypal/execute`, body).toPromise();
	}
}